import React, { useState, useEffect } from 'react';
import './index.less';
import { message } from 'antd';
import closeImg from '../../../../assets/icons/screen-recorder-colse.svg';

export default function ScreenRecorder(props) {
  const { open, close, children } = props;

  const start = () => {
    // 1. 初始化数据
    // 2. 控制滚动条不滚动
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '“100%';
  };
  const stop = () => {
    document.documentElement.style.overflow = 'auto';
    document.body.style.position = 'static';
  };
  useEffect(() => {
    if (open) {
      start();
    } else {
      stop();
    }
  }, [open]);

  return (
    <div>
      {open && (
        <div className='modal-down-mask'>
          <div className='mask'></div>
          <div className='contend'>
            <img className='close' onClick={close} src={closeImg} alt='' />
            {children}
          </div>
        </div>
      )}
    </div>
  );
}
